export default class DealershipWriteDTO {

    public id: string | undefined;
    public name: string | undefined;
    public gssn: string | undefined;
    public countryId: number | undefined;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'] || undefined;
        this.name = data['name'] || undefined;
        this.gssn = data['gssn'] || undefined;
        this.countryId = data['countryId'] || undefined;
    }
}
